import { render, staticRenderFns } from "./Chart4.vue?vue&type=template&id=b1bee004&"
import script from "./Chart4.vue?vue&type=script&lang=ts&"
export * from "./Chart4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports